import React from "react";

const PotentialProjects = ({ title, images, descriptions }) => {
  return (
    <>
      <div className="flex flex-col md:flex-row md:mx-[150px]">
        <div className="p-6 w-full md:w-1/3 text-left">
          <h1 className="text-3xl text-[#1b1b1b] font-bold mb-4">{title}</h1>

          {descriptions.map((item, index) => (
            <p className="mb-4 text-[#1b1b1b]">{item}</p>
          ))}

          <button className="bg-black text-white text-base rounded-md font-medium px-8 py-2  shadow hover:bg-gray-800 transition duration-300">
            Apply to Invest
          </button>
        </div>

        <div className="w-full md:w-2/3  p-6 ">
          {images.map((item, index) => (
            <img
              src={item}
              alt="Glamping Accommodation"
              className="w-full object-cover mb-8 rounded-3xl"
              style={{ height: "50vh" }} // Adjust height as needed
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default PotentialProjects;
